export default __webpack_public_path__ + "static/media/dani-mage.46046994.jpeg";